import { render, staticRenderFns } from "./DashboardEquipesProgressBar.vue?vue&type=template&id=1317be2c&scoped=true"
import script from "./DashboardEquipesProgressBar.vue?vue&type=script&lang=js"
export * from "./DashboardEquipesProgressBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipesProgressBar.vue?vue&type=style&index=0&id=1317be2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1317be2c",
  null
  
)

export default component.exports